import { render, staticRenderFns } from "./FareOptions.vue?vue&type=template&id=6d475d51&scoped=true&"
import script from "./FareOptions.vue?vue&type=script&lang=js&"
export * from "./FareOptions.vue?vue&type=script&lang=js&"
import style0 from "./FareOptions.vue?vue&type=style&index=0&id=6d475d51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d475d51",
  null
  
)

export default component.exports